import React, { useMemo } from 'react';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import * as T from 'prop-types';
import createDecorator from 'final-form-focus';
import _ from 'lodash';
import { BasicInfoAndContactFormSection } from './consultantInfo/BasicInfoAndContactFormSection';
import AddressInfoFormSection from './consultantInfo/AddressInfoFormSection';
import { ResumeInfoFormSection } from './consultantInfo/ResumeInfoFormSection';
import { ProfileInfoFormSection } from './consultantInfo/ProfileInfoFormSection';
import { BoardMembershipInfoFormSection } from './consultantInfo/BoardMembershipInfoFormSection';
import { ConfidentialInfoAccessSection } from './consultantInfo/ConfidentialInfoAccessSection';
import { AreaOfExpertiseInfoFormSection } from './consultantInfo/AreaOfExpertiseInfoFormSection';
import { BackgroundInfoFormSection } from './consultantInfo/BackgroundInfoFormSection';
import GenericCheckboxInputField from '../../commons/form-fields/GenericCheckboxInputField';
import Disclaimer from '../../commons/Disclaimer';
import { useAutoSaveDraft } from '../../commons/draftHooks';
import { PageErrorComponent } from '../../commons/PageErrorComponent';

const ConsultantInfoPage = (props) => (
    <div>
        <Disclaimer>
            <p>
                Application Form for becoming a consultant in D. E. Shaw
                Group&#39;s Industry Consulting Program (ICP)
            </p>
        </Disclaimer>
        <BasicInfoAndContactFormSection
            consultantCountry={props.consultantCountry}
        />
        <AddressInfoFormSection {...props} />
        <ResumeInfoFormSection />
        <ProfileInfoFormSection {...props} />
        <BoardMembershipInfoFormSection />
        <ConfidentialInfoAccessSection />
        <AreaOfExpertiseInfoFormSection />
        <BackgroundInfoFormSection />
        <GenericCheckboxInputField
            name="info.completeAndAccurateInformation"
            label={
                'Please confirm that the information provided above is complete and accurate.'
            }
            errorMsg={
                'Please confirm that above information is complete and accurate.'
            }
            required
        />
    </div>
);

ConsultantInfoPage.propTypes = {
    consultantCountry: T.string,
};

const Page1Form = (props) => {
    // return same decorator for subsequent renders.
    const focusOnError = useMemo(() => createDecorator(), []);
    return (
        <Form
            onSubmit={(values) => {
                props.nextFn(values);
            }}
            decorators={[focusOnError]}
            initialValues={props.initialValues}
            keepDirtyOnReinitialize
            render={({
                handleSubmit,
                values,
                errors,
                submitFailed,
                submitErrors,
            }) => {
                useAutoSaveDraft(props.autoSaveCallback, values, errors);

                return (
                    <div>
                        <form onSubmit={handleSubmit}>
                            <ConsultantInfoPage
                                consultantCountry={props.consultantCountry}
                            />
                            {!submitErrors && submitFailed && errors && (
                                <PageErrorComponent error={errors} />
                            )}
                            <div className="block">
                                <button
                                    className="py-5 px-4"
                                    type="button"
                                    onClick={() => _.noop()}
                                />
                                <button
                                    className="disabled:opacity-50 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded float-right"
                                    type="submit"
                                    data-testid="next-page"
                                >
                                    Next Page &#62;
                                </button>
                            </div>
                        </form>
                        {/* <pre>{JSON.stringify(values, undefined, 2)}</pre> */}
                        {/* <pre>{JSON.stringify(errors, undefined, 2)}</pre> */}
                    </div>
                );
            }}
            mutators={{
                // potentially other mutators could be merged here
                ...arrayMutators,
            }}
        />
    );
};

Page1Form.propTypes = {
    initialValues: T.object,
    consultantCountry: T.string,
    autoSaveCallback: T.func,
    nextFn: T.func,
};

export default Page1Form;
